'use client'

import { cn } from '@/lib/utils'
import { useToast } from 'design-configuration/components/toast'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport
} from 'design-configuration/components/toast/toast'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className={cn('bg-surface border-outline-variant rounded-xs !select-text border', {
              'bg-error-container text-on-error-container border-on-error-container/20': props.variant === 'destructive'
            })}
          >
            <div className="grid max-w-[320px] gap-1 overflow-auto break-words">
              {title && <ToastTitle className="text-body font-medium">{title}</ToastTitle>}
              {description && <ToastDescription className="text-body">{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose
              className={cn(
                'text-on-surface/50 hover:text-on-surface group-[.destructive]:text-on-error-container/50 group-[.destructive]:hover:text-on-error-container group-[.destructive]:focus:ring-on-error-container group-[.destructive]:focus:ring-offset-on-error-container'
              )}
            />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
